import { Link, Outlet } from 'react-router';

export default function MarketingLayout() {
  return (
    <>
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="font-bold text-xl text-primary">
            ROCA Panel
          </Link>
          <div className="flex gap-4">
            <Link to="/sign-in">
              <button className="px-4 py-2 text-sm font-medium text-primary hover:text-primary/80">
                Sign In
              </button>
            </Link>
            <Link to="/sign-up">
              <button className="px-4 py-2 text-sm font-medium bg-primary text-white rounded-md hover:bg-primary/90">
                Sign Up
              </button>
            </Link>
          </div>
        </div>
      </nav>
      <main>
        <Outlet />
      </main>
    </>
  );
}
